import { render, staticRenderFns } from "./comp-layout.vue?vue&type=template&id=9a311c36&scoped=true&lang=pug&"
import script from "./comp-layout.vue?vue&type=script&lang=js&"
export * from "./comp-layout.vue?vue&type=script&lang=js&"
import style0 from "./comp-layout.vue?vue&type=style&index=0&id=9a311c36&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a311c36",
  null
  
)

export default component.exports